export default "__VITE_ASSET__BKGpXlGN__"